import type { Asserts } from 'yup';

import { contractSchema as campContractSchema } from '@/features/Sparten/camp/schema/contractSchema';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';

export const contractSchema = campContractSchema;

export type ContractStore = Asserts<typeof contractSchema>;

export const useCampContractStore = genericStoreFactory(
  () => contractSchema.getDefault() as ContractStore,
  'CampContractStore',
);
